













































































import CShimmer from '~/components/shared/configurable/shimmer/CShimmer.vue'
import { useUserAgent } from '~/compositions/user-agent'
import { defineComponent } from '~/utils/nuxt3-migration'

export default defineComponent({
  components: { CShimmer },
  props: {
    repeat: {
      type: Number,
      default: 3
    },
    showAvatar: { type: Boolean, default: true },
    looklike: {
      type: String,
      required: false,
      default() {
        return null
      }
    }
  },
  setup() {
    const { isPc } = useUserAgent()
    return {
      isPc
    }
  }
})
